module.exports = __webpack_public_path__ + "static/media/whitebox.8a17402e.svg";